import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
    selector: 'btn-cell-renderer-edit-delete',
    template: `
		<em *ngIf="enableEdit">
		<img style="cursor:pointer;"
		src="./assets/images/edit_blue.svg" 
		(click)="btnClickedHandler('edit')"> 
		</em>

		<em *ngIf="enableDelete">
		<img [style]="pageName? 'margin-left: 10px;cursor:pointer;' : 'margin-left:14px;cursor:pointer;'"  src="./assets/images/delete_red.svg" 
		(click)="btnClickedHandler('delete')">
		</em>`,
    standalone: false
})
export class BtnCellRendererEditDelete implements ICellRendererAngularComp, OnDestroy {



	refresh(_params: ICellRendererParams): boolean {
		return false;
	}

	private params: any;
	pageName;
	enableEdit: boolean = false;
	enableDelete: boolean = false;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;

		//tier
		if (this.params.colDef.field == "tiers_editdelete") {  // NOSONAR
			this.enableEdit = true;
			this.enableDelete = true;
			if (params.data.tierposition == 1) {  // NOSONAR
				this.enableEdit = false;
			}
		}

		//shuttle
		if (this.params.colDef.field == "shuttles_editdelete") {  // NOSONAR
			this.enableDelete = true;
			this.enableEdit = true;
		}

		//ew-configuration
		if (this.params.colDef.field == "ewconfiguration_editdelete") {  // NOSONAR
			this.enableDelete = true;
			this.enableEdit = true;
		}

		//periods
		if (this.params.colDef.field == "periods_editdelete") {  // NOSONAR
			this.enableEdit = true;
			this.enableDelete = true;
		}
	}

	btnClickedHandler(action) {

		if (action == 'delete') {  // NOSONAR
			this.params.context.componentParent.deleteTemplateRow(this.params.data, this.pageName);
		}

		else if (action == 'edit') {  // NOSONAR
			this.params.context.componentParent.editTemplateRow(this.params.data, this.pageName);
		}
	}

	ngOnDestroy() {
console.info()


	}
}
